import { render } from "./CompanyEditModal.vue?vue&type=template&id=4cfabfc2"
import script from "./CompanyEditModal.vue?vue&type=script&lang=js"
export * from "./CompanyEditModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__